import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="d-sm-flex justify-content-center justify-content-center">
          <span className="text-muted text-center d-block d-sm-inline-block">
            Copyright © 2025 <a href="#" target=""></a>. All rights reserved.
          </span>
        </div>
      </footer>
    </>
  );
};

export default Footer;
